export const COMBO_RESET_FRAMES = 2;

const DAMAGE_SCALE = [
  1,
  1,
  0.9,
  0.8,
  0.7,
  0.6,
  0.5,
  0.4,
  0.3,
  0.2,
  0.1,
  0.05,
] as const;

export interface ComboScaling {
  damage: number;
  knockback: number;
  hitstun: number;
}

function normalizedStep(step: number): number {
  if (!Number.isFinite(step)) {
    return 1;
  }
  return Math.max(1, Math.floor(step));
}

export function comboScalingForStep(step: number): ComboScaling {
  const comboStep = normalizedStep(step);
  const ladderIndex = Math.min(comboStep, DAMAGE_SCALE.length) - 1;
  const reductionSteps = Math.min(
    Math.max(0, comboStep - 2),
    DAMAGE_SCALE.length - 2,
  );
  return {
    damage: DAMAGE_SCALE[ladderIndex]!,
    knockback: Number(Math.max(0.8, 1 - reductionSteps * 0.02).toFixed(2)),
    hitstun: Number(Math.max(0.5, 1 - reductionSteps * 0.05).toFixed(2)),
  };
}

export function scaleComboDamage(baseDamage: number, step: number): number {
  return Math.round(baseDamage * comboScalingForStep(step).damage);
}
